import validateAmmount from '@/helpers/validateAmmount'

export default {
  getMessage (field, args) {
    return field
  },
  validate (value, args) {
    return validateAmmount(value)
  }
}
